import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	callHistory__search: 'mw/CallHistory/search',
};

const normalizeNullablePositiveInteger = (value) => {
	if (value === null || value === undefined || value === '') {
		return null;
	}

	if (typeof value === 'object') {
		const extracted = value?.id ?? value?.value ?? value?.customerId ?? value?.contactPersonId;
		if (extracted !== undefined) {
			return normalizeNullablePositiveInteger(extracted);
		}

		return null;
	}

	if (typeof value !== 'string' && typeof value !== 'number') {
		return null;
	}

	const normalized = String(value).trim();
	if (!/^[1-9][0-9]*$/.test(normalized)) {
		return null;
	}

	return Number(normalized);
};

const sanitizeCallHistoryBody = (body = {}) => ({
	...body,
	customerId: normalizeNullablePositiveInteger(body.customerId),
	contactPersonId: normalizeNullablePositiveInteger(body.contactPersonId),
});

export const callHistoryApi = createApi({
	reducerPath: 'mw/callHistoryApi',

	endpoints: (builder) => ({
		callHistorySearch: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/CallHistory/search',
				body: sanitizeCallHistoryBody(body),
				jsonType: true,
			}),
			providesTags: [tags.callHistory__search],
		}),
	}),
});

export const {
	callHistorySearch,
} = callHistoryApi.endpoints;

export default callHistoryApi;
